import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.docs.form');
import { OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import html2pdf from 'html2pdf.js';
import { Service } from "src/libs/portal/season/service";

const DOC_GULIM_FONT_FAMILY = "'SeasonDocumentGulim', '굴림체', 'GulimChe', '굴림', Gulim, sans-serif";
const DOC_DOTUM_FONT_FAMILY = "'SeasonDocumentDotum', '돋움체', 'DotumChe', '돋움', Dotum, sans-serif";
const DOC_BATANG_FONT_FAMILY = "'SeasonDocumentBatang', '바탕체', 'BatangChe', '바탕', Batang, serif";
const DOC_HEADER_HY_FONT_FAMILY = "'SeasonHeaderHYGothic', 'HY견고딕', 'HYGothic-Extra', sans-serif";
const DEFAULT_DOC_FONT_SIZE = '12pt';
const DEFAULT_DOC_TEXT_COLOR = '#000000';
const DEFAULT_DOC_HIGHLIGHT_COLOR = '#ffff00';
const DEFAULT_DOC_TEXT_ALIGN = 'left';
const DEFAULT_DOC_LINE_HEIGHT = '1.6';
const PAGE_GAP_PX = 28;
const DEFAULT_PAGE_LAYOUT = {
    size: 'A4',
    widthMm: 210,
    heightMm: 297,
    orientation: 'portrait',
    marginLeftMm: 30,
    marginRightMm: 30,
    marginTopMm: 20,
    marginBottomMm: 10,
    headerMm: 10,
    footerMm: 10,
    gutterMm: 0,
};
const FONT_SIZE_OPTIONS = [
    { label: '8pt', value: '8pt', legacy: '1' },
    { label: '10pt', value: '10pt', legacy: '2' },
    { label: '12pt', value: '12pt', legacy: '3' },
    { label: '14pt', value: '14pt', legacy: '4' },
    { label: '18pt', value: '18pt', legacy: '5' },
    { label: '24pt', value: '24pt', legacy: '6' },
    { label: '36pt', value: '36pt', legacy: '7' },
];

const DOC_KIND_TEMPLATES: any = {
    official: ['내부결재', '시행문', '공문'],
    report: ['보고서'],
    table: ['회의록', '출장보고서', '지출결의서', '면접평가표', '퇴직자 점검 확인서'],
    cert: ['경력증명서', '재직증명서', '퇴직증명서'],
    contract: ['근로계약서', '연봉계약서', '보안유지서약서', '보안유지 서약서'],
    application: ['휴가신청서', '휴직신청서', '복직신청서', '사직서', '임산부단축근무신청서', '출산전후휴가 및 육아휴직 신청서'],
};

const DOCUMENT_STYLE_PRESETS: any = {
    official: {
        fontFamily: DOC_GULIM_FONT_FAMILY,
        fontSize: '12pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'left',
        lineHeight: '1.6',
    },
    report: {
        fontFamily: DOC_GULIM_FONT_FAMILY,
        fontSize: '11pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'left',
        lineHeight: '1.7',
    },
    table: {
        fontFamily: DOC_DOTUM_FONT_FAMILY,
        fontSize: '10pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'left',
        lineHeight: '1.45',
    },
    cert: {
        fontFamily: DOC_BATANG_FONT_FAMILY,
        fontSize: '11pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'left',
        lineHeight: '1.75',
    },
    contract: {
        fontFamily: DOC_BATANG_FONT_FAMILY,
        fontSize: '11pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'justify',
        lineHeight: '1.75',
    },
    application: {
        fontFamily: DOC_GULIM_FONT_FAMILY,
        fontSize: '11pt',
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: 'left',
        lineHeight: '1.55',
    },
};

const PAGE_LAYOUT_PRESETS: any = {
    official: {},
    report: { marginLeftMm: 26, marginRightMm: 26, marginTopMm: 20, marginBottomMm: 12 },
    table: { marginLeftMm: 20, marginRightMm: 20, marginTopMm: 18, marginBottomMm: 10 },
    cert: { marginLeftMm: 28, marginRightMm: 28, marginTopMm: 26, marginBottomMm: 18 },
    contract: { marginLeftMm: 24, marginRightMm: 24, marginTopMm: 24, marginBottomMm: 16 },
    application: { marginLeftMm: 24, marginRightMm: 24, marginTopMm: 22, marginBottomMm: 14 },
};

@Component({
    selector: 'wiz-page-docs-form',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.docs.form/view.scss */
@charset "UTF-8";
:host {
  --editor-header-offset: 78px;
  display: block;
  min-height: 100%;
  background: #ffffff;
}

.editor-shell {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - var(--editor-header-offset));
}

.editor-shell__inner {
  width: min(100%, 1220px);
  margin: 0 auto;
  padding: 0 24px;
}

.editor-topbar {
  position: sticky;
  top: var(--editor-header-offset);
  z-index: 24;
  border-bottom: 1px solid rgba(228, 229, 231, 0.88);
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(14px);
}

.editor-topbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 0 16px;
}

.editor-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.editor-heading__copy {
  min-width: 0;
}

.editor-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 14px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.88);
  color: #334155;
  flex-shrink: 0;
}

.editor-kicker {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(224, 231, 255, 0.7);
  color: #4338ca;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.editor-title {
  margin: 4px 0 0;
  color: #0f172a;
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 360px;
}

.step-indicator {
  display: flex;
  align-items: center;
  gap: 0;
  flex-shrink: 0;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(241, 245, 249, 0.8);
  border: 1px solid rgba(226, 232, 240, 0.8);
  cursor: default;
  transition: all 0.2s;
}

.step-item.step-active {
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  border-color: transparent;
}
.step-item.step-active .step-num, .step-item.step-active .step-label {
  color: #fff;
}

.step-item.step-done {
  background: rgba(224, 231, 255, 0.7);
  border-color: rgba(199, 210, 254, 0.9);
  cursor: pointer;
}
.step-item.step-done .step-num {
  color: #4338ca;
}
.step-item.step-done .step-label {
  color: #4338ca;
}

.step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.06);
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
}

.step-active .step-num {
  background: rgba(255, 255, 255, 0.2);
}

.step-done .step-num {
  background: rgba(67, 56, 202, 0.15);
}

.step-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.step-line {
  width: 28px;
  height: 2px;
  background: #e2e8f0;
  margin: 0 4px;
}

.step-line--done {
  background: #a5b4fc;
}

.editor-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.9);
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}
.editor-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.editor-btn--primary {
  border-color: transparent;
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.14);
}

.editor-btn--ghost {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.9) 100%);
}

.editor-btn--active {
  border-color: rgba(129, 140, 248, 0.9);
  box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.12);
}

.editor-btn--soft {
  min-height: 36px;
  background: rgba(224, 231, 255, 0.76);
  color: #4338ca;
  border-color: rgba(199, 210, 254, 0.9);
}

.download-menu-wrap {
  position: relative;
  display: inline-flex;
}

.editor-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  margin-top: 0;
  min-width: 170px;
  padding: 8px;
  border-radius: 18px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 30px rgba(15, 23, 42, 0.12);
  z-index: 80;
}

.editor-menu--download {
  min-width: 190px;
}

.editor-menu__item {
  display: block;
  width: 100%;
  min-height: 38px;
  padding: 0 12px;
  border-radius: 12px;
  border: 0;
  background: transparent;
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}
.editor-menu__item:hover {
  background: rgba(248, 250, 252, 0.95);
}

.editor-body {
  flex: 1 0 auto;
  overflow: visible;
  padding: 28px 0 72px;
}

.meta-form {
  max-width: 820px;
  margin: 0 auto;
  padding: 32px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 24px 56px rgba(148, 163, 184, 0.1);
}

.meta-form__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

.meta-form__desc {
  margin: 6px 0 24px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
}

.meta-table {
  display: flex;
  flex-direction: column;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.meta-row {
  display: flex;
  align-items: stretch;
  min-height: 48px;
  border-bottom: 1px solid #f1f5f9;
}
.meta-row:last-child {
  border-bottom: 0;
}

.meta-label {
  display: flex;
  align-items: center;
  width: 140px;
  flex-shrink: 0;
  padding: 10px 16px;
  background: #f8fafc;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  border-right: 1px solid #f1f5f9;
}

.meta-label--required::after {
  content: "*";
  color: #ef4444;
  margin-left: 4px;
}

.meta-value {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 8px 16px;
  gap: 8px;
  flex-wrap: wrap;
}

.meta-value--radios,
.meta-value--checks {
  gap: 6px;
}

.meta-input {
  width: 100%;
  max-width: 400px;
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #fff;
  font-size: 13px;
  color: #0f172a;
  outline: none;
}
.meta-input:focus {
  border-color: rgba(99, 102, 241, 0.6);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.08);
}

.meta-input--readonly {
  background: #f8fafc;
  color: #475569;
  cursor: default;
}

.meta-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}

.meta-badge--accent {
  background: rgba(224, 231, 255, 0.9);
  color: #4338ca;
}

.meta-badge--muted {
  background: #f1f5f9;
  color: #94a3b8;
}

.meta-radio,
.meta-check {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s;
}
.meta-radio:hover,
.meta-check:hover {
  background: #f1f5f9;
}
.meta-radio input[type=radio],
.meta-radio input[type=checkbox],
.meta-check input[type=radio],
.meta-check input[type=checkbox] {
  accent-color: #4338ca;
  margin: 0;
}

.meta-section {
  margin-top: 24px;
  padding: 20px;
  border-radius: 18px;
  background: rgba(248, 250, 252, 0.7);
  border: 1px solid #e2e8f0;
}

.meta-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.meta-section__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.meta-section__desc {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
}

.meta-section__body {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.editor-approval-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.editor-approval-chip__role,
.editor-approval-chip__name {
  height: 30px;
  border: 0;
  background: transparent;
  outline: none;
  text-align: center;
  font-size: 12px;
}

.editor-approval-chip__role {
  width: 64px;
  font-weight: 600;
  color: #334155;
}

.editor-approval-chip__name {
  width: 72px;
  color: #475569;
}

.editor-approval-chip__remove {
  color: #94a3b8;
  cursor: pointer;
}

.meta-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.editor-toolbar-shell {
  position: relative;
  z-index: 12;
  padding: 14px 0 0;
  background: transparent;
  border-bottom: 0;
  backdrop-filter: none;
}

.editor-toolbar-scroll {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  overflow-x: auto;
  padding: 12px 14px;
  border-radius: 18px;
  border: 1px solid rgba(226, 232, 240, 0.92);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 14px 34px rgba(148, 163, 184, 0.08);
  scrollbar-width: none;
}
.editor-toolbar-scroll::-webkit-scrollbar {
  display: none;
}

.toolbar-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 2px;
}

.toolbar-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.94);
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.toolbar-pill--ghost {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.9) 100%);
}

.toolbar-pill--primary {
  border-color: transparent;
  background: linear-gradient(135deg, #111827 0%, #334155 100%);
  color: #ffffff;
}

.editor-stage {
  flex: 1 0 auto;
  min-height: 0;
  overflow: visible;
  padding: 22px 0 72px;
}

.editor-stage__inner {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}

.editor-stage__tip {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.step2-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  flex-wrap: wrap;
}

.editor-canvas-scroll {
  overflow-x: auto;
  overflow-y: visible;
  padding: 12px 12px 20px;
  border-radius: 28px;
  border: 1px solid rgba(226, 232, 240, 0.85);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.editor-canvas-frame {
  display: flex;
  justify-content: center;
  min-width: max-content;
  padding: 8px 8px 34px;
}

.a4-paper {
  width: var(--page-width-mm, 210mm);
  min-height: var(--page-height-mm, 297mm);
  box-sizing: border-box;
  position: relative;
}

.editor-paper {
  background: transparent;
}

.paged-paper {
  --page-gap-px: 28px;
  display: flex;
  flex-direction: column;
  gap: var(--page-gap-px);
}

.paged-paper__sheet {
  width: var(--page-width-mm, 210mm);
  min-height: var(--page-height-mm, 297mm);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  background: linear-gradient(180deg, #ffffff 0%, #fcfcfb 100%);
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.14);
}

.paged-paper__content {
  position: absolute;
  inset: 0;
  padding: var(--page-margin-top-mm, 20mm) var(--page-margin-right-mm, 30mm) var(--page-margin-bottom-mm, 10mm) var(--page-margin-left-mm, 30mm);
  box-sizing: border-box;
}

.toolbar-select {
  font-size: 12px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 12px;
  padding: 3px 10px;
  outline: none;
  background: rgba(255, 255, 255, 0.92);
  cursor: pointer;
  height: 38px;
  color: #334155;
}
.toolbar-select:hover {
  border-color: #a5b4fc;
}
.toolbar-select:focus {
  border-color: #818cf8;
  box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.12);
}

.toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  color: #374151;
  transition: all 0.1s ease;
}
.toolbar-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.toolbar-btn:active {
  background: #e2e8f0;
}

.toolbar-btn--active {
  background: rgba(224, 231, 255, 0.92);
  border-color: rgba(129, 140, 248, 0.9);
  color: #4338ca;
}

.toolbar-sep {
  display: inline-block;
  width: 1px;
  height: 24px;
  background: #e2e8f0;
  margin: 0 4px;
}

.preview-body {
  flex: 1 0 auto;
  overflow: visible;
  padding: 24px 0 72px;
}

.preview-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.preview-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 18px;
  margin-bottom: 22px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(226, 232, 240, 0.9);
  box-shadow: 0 14px 32px rgba(148, 163, 184, 0.08);
}

.preview-summary__item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f8fafc;
  font-size: 12px;
}

.preview-summary__label {
  font-weight: 600;
  color: #64748b;
}

.preview-summary__value {
  color: #0f172a;
  font-weight: 500;
}

.preview-paper {
  pointer-events: none;
  user-select: text;
}

.preview-paper .paged-paper__content {
  pointer-events: none;
}

::ng-deep .doc-field-input {
  border: 1px solid transparent;
  border-radius: 2px;
  padding: 1px 4px;
  background: transparent;
  outline: none;
  font: inherit;
  color: inherit;
  transition: all 0.15s ease;
  width: 100%;
  box-sizing: border-box;
}
::ng-deep .doc-field-input:hover {
  border-color: #c7d2fe;
  background: #f5f7ff;
}
::ng-deep .doc-field-input:focus {
  border-color: #818cf8;
  background: #fafbff;
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.15);
}
::ng-deep .doc-field-input::placeholder {
  color: #c7c7c7;
  font-style: italic;
  font-size: 12px;
}

::ng-deep .doc-field-richtext {
  display: inline-block;
  width: 100%;
  min-height: 1.4em;
  line-height: inherit;
  outline: none;
  color: inherit;
  white-space: pre-wrap;
}
::ng-deep .doc-field-richtext:empty::before {
  content: attr(data-placeholder);
  color: #c7c7c7;
  font-style: italic;
  font-size: 12px;
  pointer-events: none;
}

::ng-deep .doc-body .doc-field-richtext {
  min-height: 40px;
}

::ng-deep .doc-field-select {
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  padding-right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M3 5l3 3 3-3' fill='none' stroke='%23999' stroke-width='1.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 4px center;
}

::ng-deep .doc-field-checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
}

::ng-deep .doc-field-checkbox {
  cursor: pointer;
  accent-color: #6366f1;
}

::ng-deep .doc-container {
  font-family: var(--doc-font-family, "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif);
  font-size: var(--doc-font-size, 12pt);
  width: 100%;
  max-width: none;
  margin: 0;
  color: var(--doc-text-color, #000);
  line-height: var(--doc-line-height, 1.6);
  letter-spacing: -0.02em;
}

::ng-deep .doc-container * {
  font-family: inherit;
}

::ng-deep .doc-container input,
::ng-deep .doc-container textarea,
::ng-deep .doc-container select,
::ng-deep .doc-container option {
  font-family: inherit;
}

::ng-deep .doc-field-row,
::ng-deep .doc-field-value,
::ng-deep .doc-body,
::ng-deep .doc-table,
::ng-deep .doc-cert-statement,
::ng-deep .doc-date-center,
::ng-deep .doc-clause,
::ng-deep .doc-dual-sign,
::ng-deep .doc-check-table {
  color: inherit;
}

::ng-deep .doc-header-top {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
::ng-deep .doc-header-top .logo-area {
  flex-shrink: 0;
  width: 140px;
}
::ng-deep .doc-header-top .logo-area img {
  width: 126px;
  height: auto;
}
::ng-deep .doc-header-top .company-name {
  flex: 1;
  text-align: center;
  font-size: 18pt;
  font-weight: 400;
  font-family: "SeasonHeaderHYGothic", "HY견고딕", "HYGothic-Extra", sans-serif !important;
  letter-spacing: 1px;
  color: #000;
}
::ng-deep .doc-header-top .header-right {
  flex-shrink: 0;
  width: 140px;
}

::ng-deep .doc-confidential {
  text-align: center;
  font-size: 8pt;
  color: #555;
  margin-bottom: 8px;
}

::ng-deep .doc-header-gap {
  height: 96px;
}

::ng-deep .doc-classify {
  font-size: 12pt;
  margin-bottom: 2px;
}
::ng-deep .doc-classify .classify-label {
  color: #c75252;
}

::ng-deep .doc-field-row {
  display: flex;
  margin-bottom: 0;
  font-size: 12pt;
  line-height: 1.6;
}

::ng-deep .doc-field-label {
  font-weight: normal;
  min-width: 44px;
  flex-shrink: 0;
}

::ng-deep .doc-field-label-colored {
  color: #c75252;
}

::ng-deep .doc-field-value {
  flex: 1;
}

::ng-deep .doc-subject-row {
  display: flex;
  font-size: 12pt;
  line-height: 1.6;
  padding-bottom: 6px;
  border-bottom: 1px solid #000;
  margin-bottom: 8px;
}
::ng-deep .doc-subject-row .doc-field-label {
  font-weight: normal;
}

::ng-deep .doc-body {
  font-size: inherit;
  line-height: var(--doc-line-height, 1.8);
  text-align: var(--doc-text-align, left);
  margin-top: 6px;
  clear: both;
}
::ng-deep .doc-body p {
  margin: 4px 0;
  text-indent: 0;
}
::ng-deep .doc-body .attach-title {
  font-weight: normal;
  margin-top: 12px;
}
::ng-deep .doc-body .attach-list {
  margin-left: 12px;
}
::ng-deep .doc-body p, ::ng-deep .doc-body div, ::ng-deep .doc-body li {
  text-indent: 0 !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
::ng-deep .doc-body .attach-list {
  margin-left: 12px !important;
}

::ng-deep .doc-field-richtext p, ::ng-deep .doc-field-richtext div, ::ng-deep .doc-field-richtext li {
  text-indent: 0 !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

::ng-deep .doc-bottom-section {
  margin-top: 24px;
  color: #000 !important;
  font-family: "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif !important;
  font-size: 8pt !important;
  line-height: 1.5 !important;
  break-inside: avoid;
  page-break-inside: avoid;
}

::ng-deep .doc-bottom-title {
  text-align: center;
  font-family: "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif !important;
  font-size: 15pt !important;
  font-weight: 700;
  line-height: 1.25 !important;
  margin-bottom: 14px;
}

::ng-deep .doc-bottom-recipient-row,
::ng-deep .doc-bottom-helper-row,
::ng-deep .doc-bottom-info-row {
  display: grid;
  align-items: center;
  color: #000 !important;
}

::ng-deep .doc-bottom-recipient-row {
  grid-template-columns: 72px minmax(0, 1fr);
  column-gap: 10px;
  min-height: 24px;
  margin-bottom: 8px;
}

::ng-deep .doc-bottom-recipient-row__label,
::ng-deep .doc-bottom-helper-row__label,
::ng-deep .doc-bottom-info-cell--label {
  font-family: "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif !important;
  font-size: 8pt !important;
  font-weight: 400;
  white-space: nowrap;
}

::ng-deep .doc-bottom-recipient-row__value,
::ng-deep .doc-bottom-helper-row__value,
::ng-deep .doc-bottom-info-cell--value,
::ng-deep .doc-bottom-approval-freeform {
  font-family: "SeasonDocumentGulim", "굴림체", "GulimChe", "굴림", Gulim, sans-serif !important;
  font-size: 8pt !important;
  font-weight: 400;
}

::ng-deep [data-bottom-field][contenteditable=true] {
  outline: none;
  border-bottom: 1px dashed #ccc;
  min-width: 20px;
}
::ng-deep [data-bottom-field][contenteditable=true]:focus {
  border-bottom-color: #4285f4;
  background: rgba(66, 133, 244, 0.04);
}

::ng-deep .doc-bottom-divider {
  height: 8px;
  background: #cccccc;
  margin: 2px 0 12px;
}

::ng-deep .doc-bottom-approval-freeform {
  min-height: 26px;
  margin-bottom: 14px;
  padding: 2px 0 4px;
  border-bottom: 1px dashed #d4d4d4;
  line-height: 1.8 !important;
  white-space: pre-wrap;
}

::ng-deep .doc-bottom-helper-row {
  grid-template-columns: 72px minmax(0, 1fr);
  column-gap: 10px;
  min-height: 24px;
  margin-bottom: 8px;
}

::ng-deep .doc-bottom-info-row {
  column-gap: 10px;
  min-height: 24px;
  margin-bottom: 6px;
}

::ng-deep .doc-bottom-info-row--issue {
  grid-template-columns: 46px minmax(0, 1.7fr) minmax(0, 0.9fr) 40px minmax(0, 1fr);
}

::ng-deep .doc-bottom-info-row--address {
  grid-template-columns: 24px 64px minmax(0, 1fr) auto;
}

::ng-deep .doc-bottom-info-row--contact {
  grid-template-columns: 58px minmax(0, 1fr) 58px minmax(0, 1fr) 42px minmax(0, 1.1fr);
}

::ng-deep .doc-bottom-info-cell--date {
  text-align: center;
}

::ng-deep .doc-bottom-info-cell--website {
  text-align: right;
}

::ng-deep .doc-bottom-info-cell[data-bottom-field=email] {
  text-align: right;
}

::ng-deep .doc-title-center {
  text-align: center;
  font-size: 20pt;
  font-weight: bold;
  letter-spacing: 8px;
  margin: 24px 0;
  color: #000;
}

::ng-deep .doc-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12pt;
}
::ng-deep .doc-table th, ::ng-deep .doc-table td {
  border: 1px solid #000;
  padding: 6px 10px;
  text-align: left;
  vertical-align: top;
  line-height: 1.6;
}
::ng-deep .doc-table th {
  background: #f7f7f7;
  font-weight: 600;
  width: 110px;
  white-space: nowrap;
  text-align: center;
}
::ng-deep .doc-table td {
  min-height: 24px;
}

::ng-deep .doc-cert-statement {
  text-align: center;
  font-size: 14pt;
  margin: 24px 0;
  line-height: 1.8;
}

::ng-deep .doc-date-center {
  text-align: center;
  font-size: 12pt;
  margin: 16px 0 8px 0;
}

::ng-deep .doc-sign-area {
  text-align: center;
  margin-top: 24px;
  font-size: 14pt;
  line-height: 2;
}
::ng-deep .doc-sign-area .org-name {
  font-weight: bold;
  font-size: 15pt;
}
::ng-deep .doc-sign-area .seal-text {
  font-size: 10pt;
  color: #888;
}

::ng-deep .doc-clause {
  margin: 4px 0;
  padding-left: 4px;
  line-height: 1.8;
  font-size: 12pt;
}

::ng-deep .doc-dual-sign {
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
  font-size: 12pt;
}
::ng-deep .doc-dual-sign .sign-block {
  text-align: center;
  line-height: 2;
}

::ng-deep .doc-check-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12pt;
}
::ng-deep .doc-check-table th, ::ng-deep .doc-check-table td {
  border: 1px solid #000;
  padding: 5px 8px;
}
::ng-deep .doc-check-table th {
  background: #f7f7f7;
  font-weight: 600;
  text-align: center;
}
::ng-deep .doc-check-table td {
  text-align: center;
}

::ng-deep .doc-container.doc-kind-report {
  letter-spacing: -0.01em;
}
::ng-deep .doc-container.doc-kind-report .doc-header-gap {
  height: 76px;
}
::ng-deep .doc-container.doc-kind-report .doc-header-top + .doc-classify,
::ng-deep .doc-container.doc-kind-report .doc-header-top + .doc-field-row,
::ng-deep .doc-container.doc-kind-report .doc-header-top + .doc-subject-row {
  margin-top: 76px !important;
}
::ng-deep .doc-container.doc-kind-report .doc-body {
  font-size: var(--doc-font-size, 11pt);
  line-height: var(--doc-line-height, 1.7);
}
::ng-deep .doc-container.doc-kind-report .doc-body strong {
  font-weight: 700;
}

::ng-deep .doc-container.doc-kind-table {
  letter-spacing: 0;
}
::ng-deep .doc-container.doc-kind-table .doc-header-gap {
  height: 64px;
}
::ng-deep .doc-container.doc-kind-table .doc-header-top + .doc-classify,
::ng-deep .doc-container.doc-kind-table .doc-header-top + .doc-field-row,
::ng-deep .doc-container.doc-kind-table .doc-header-top + .doc-subject-row {
  margin-top: 64px !important;
}
::ng-deep .doc-container.doc-kind-table .doc-classify,
::ng-deep .doc-container.doc-kind-table .doc-field-row,
::ng-deep .doc-container.doc-kind-table .doc-subject-row,
::ng-deep .doc-container.doc-kind-table .doc-body,
::ng-deep .doc-container.doc-kind-table .doc-table,
::ng-deep .doc-container.doc-kind-table .doc-check-table {
  font-size: var(--doc-font-size, 10pt);
  line-height: var(--doc-line-height, 1.45);
}
::ng-deep .doc-container.doc-kind-table .doc-table th,
::ng-deep .doc-container.doc-kind-table .doc-table td,
::ng-deep .doc-container.doc-kind-table .doc-check-table th,
::ng-deep .doc-container.doc-kind-table .doc-check-table td {
  padding: 4px 7px;
}
::ng-deep .doc-container.doc-kind-table .doc-table th {
  width: 92px;
}
::ng-deep .doc-container.doc-kind-table .doc-title-center {
  font-size: 18pt;
  margin: 18px 0;
}

::ng-deep .doc-container.doc-kind-cert {
  letter-spacing: 0;
}
::ng-deep .doc-container.doc-kind-cert .doc-header-gap {
  height: 56px;
}
::ng-deep .doc-container.doc-kind-cert .doc-title-center {
  font-size: 21pt;
  letter-spacing: 10px;
  margin: 32px 0 24px;
}
::ng-deep .doc-container.doc-kind-cert .doc-body,
::ng-deep .doc-container.doc-kind-cert .doc-table {
  font-size: var(--doc-font-size, 11pt);
  line-height: var(--doc-line-height, 1.75);
}
::ng-deep .doc-container.doc-kind-cert .doc-table th {
  width: 102px;
  background: #fafafa;
  font-weight: 600;
}
::ng-deep .doc-container.doc-kind-cert .doc-cert-statement {
  font-size: 13pt;
  margin: 30px 0 18px;
  line-height: 1.9;
}
::ng-deep .doc-container.doc-kind-cert .doc-date-center {
  font-size: 11pt;
  margin-top: 22px;
}
::ng-deep .doc-container.doc-kind-cert .doc-sign-area {
  font-size: 13pt;
  margin-top: 22px;
}

::ng-deep .doc-container.doc-kind-contract {
  letter-spacing: 0;
}
::ng-deep .doc-container.doc-kind-contract .doc-header-gap {
  height: 52px;
}
::ng-deep .doc-container.doc-kind-contract .doc-title-center {
  font-size: 20pt;
  letter-spacing: 8px;
  margin: 26px 0 20px;
}
::ng-deep .doc-container.doc-kind-contract .doc-body,
::ng-deep .doc-container.doc-kind-contract .doc-clause,
::ng-deep .doc-container.doc-kind-contract .doc-dual-sign {
  font-size: var(--doc-font-size, 11pt);
  line-height: var(--doc-line-height, 1.75);
  text-align: var(--doc-text-align, justify);
}
::ng-deep .doc-container.doc-kind-contract .doc-table {
  font-size: 10.5pt;
}
::ng-deep .doc-container.doc-kind-contract .doc-table th,
::ng-deep .doc-container.doc-kind-contract .doc-table td {
  padding: 5px 8px;
}
::ng-deep .doc-container.doc-kind-contract .doc-dual-sign {
  margin-top: 34px;
}

::ng-deep .doc-container.doc-kind-application {
  letter-spacing: -0.01em;
}
::ng-deep .doc-container.doc-kind-application .doc-header-gap {
  height: 60px;
}
::ng-deep .doc-container.doc-kind-application .doc-title-center {
  font-size: 19pt;
  letter-spacing: 6px;
  margin: 22px 0 18px;
}
::ng-deep .doc-container.doc-kind-application .doc-body,
::ng-deep .doc-container.doc-kind-application .doc-table,
::ng-deep .doc-container.doc-kind-application .doc-field-row,
::ng-deep .doc-container.doc-kind-application .doc-subject-row {
  font-size: var(--doc-font-size, 11pt);
  line-height: var(--doc-line-height, 1.55);
}
::ng-deep .doc-container.doc-kind-application .doc-table th {
  width: 96px;
}
::ng-deep .doc-container.doc-kind-application .doc-table th,
::ng-deep .doc-container.doc-kind-application .doc-table td {
  padding: 5px 8px;
}
::ng-deep .doc-container.doc-kind-application .doc-cert-statement {
  font-size: 12pt;
  margin: 20px 0 12px;
  line-height: 1.7;
}
::ng-deep .doc-container.doc-kind-application .doc-sign-area {
  font-size: 12pt;
  margin-top: 18px;
}

@media (max-width: 960px) {
  .editor-shell__inner {
    padding: 0 16px;
  }
  .editor-topbar, .editor-toolbar-shell {
    position: static;
  }
  .editor-topbar__inner {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .step-indicator {
    justify-content: center;
  }
  .meta-label {
    width: 120px;
  }
  .editor-canvas-frame {
    justify-content: flex-start;
  }
  .preview-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .step2-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .editor-body,
  .editor-stage,
  .preview-body {
    padding: 20px 0 56px;
  }
}
@media (max-width: 640px) {
  .editor-shell__inner {
    padding: 0 12px;
  }
  .editor-title {
    font-size: 17px;
    max-width: 200px;
  }
  .step-label {
    display: none;
  }
  .step-item {
    padding: 6px 10px;
  }
  .meta-row {
    flex-direction: column;
  }
  .meta-label {
    width: 100%;
    border-right: 0;
    border-bottom: 1px solid #f1f5f9;
    padding: 8px 14px;
  }
  .meta-value {
    padding: 8px 14px;
  }
  .meta-input {
    max-width: 100%;
  }
  .meta-form {
    padding: 18px;
    border-radius: 18px;
  }
  .editor-btn, .toolbar-select, .toolbar-btn, .toolbar-pill {
    min-height: 36px;
    height: 36px;
  }
  .editor-toolbar-scroll {
    padding: 10px 10px;
    border-radius: 16px;
  }
  .editor-approval-chip {
    width: 100%;
    justify-content: space-between;
  }
  .editor-approval-chip__role, .editor-approval-chip__name {
    width: 40%;
  }
  .editor-canvas-scroll {
    padding: 10px 8px 18px;
    border-radius: 22px;
  }
  .a4-paper {
    width: 780px;
    min-height: 1080px;
    padding: 34px 28px;
    border-radius: 22px;
  }
  .preview-summary {
    flex-direction: column;
    gap: 6px;
  }
}
@media (min-width: 640px) {
  :host {
    --editor-header-offset: 88px;
  }
}`],
})
export class PageDocsFormComponent implements OnInit, OnDestroy {
    // ── Step Navigation ──
    public currentStep: number = 1; // 1=메타입력, 2=본문편집, 3=미리보기

    // ── Options (from API) ──
    public options: any = {
        departments: [],
        org_codes: [],
        doc_types: [],
        doc_handlings: [],
        doc_grades: [],
        publicity_options: [],
        record_types: [],
    };

    // ── Meta fields (Step 1) ──
    public department: string = '';
    public orgCode: string = '';
    public docType: string = '내부결재';
    public docHandling: any = { '전산': true };
    public recipient: string = '';
    public via: string = '';
    public docTitle: string = '';
    public execDate: string = '';
    public docGrade: string = '일반';
    public isUrgent: boolean = false;
    public publicity: string = '공개';
    public recordType: string = '전자';
    public authorName: string = '';

    // ── Approval lines ──
    public approvalLines: any[] = [];
    private defaultApprovalLines = [
        { label: '담당', name: '' },
        { label: '팀장', name: '' },
        { label: '부장', name: '' },
        { label: '센터장', name: '' },
        { label: '대표이사', name: '' }
    ];
    private companyInfo = {
        name: '주식회사 시즌',
        ceo: '대표이사',
        zip: '30127',
        address: '세종특별자치시 한누리대로 219, 한림프라자 503호',
        website: 'https://season.co.kr',
        phone: '(044)862-7370',
        fax: '(044)862-6588',
        email: 'contact@season.co.kr',
    };

    // ── Template / Document ──
    public template: any = null;
    public formData: any = {};
    public fields: any[] = [];
    public loading: boolean = true;
    public saving: boolean = false;
    public downloading: boolean = false;
    public docId: string = '';
    public templateId: string = '';
    public docNumber: string = '';
    public categories: string[] = [];
    public selectedCategory: string = '';

    // ── Font / Toolbar (Step 2) ──
    public fontOptions = [
        { label: '굴림체', value: DOC_GULIM_FONT_FAMILY },
        { label: '돋움', value: DOC_DOTUM_FONT_FAMILY },
        { label: '바탕', value: DOC_BATANG_FONT_FAMILY },
        { label: '나눔고딕', value: "'Nanum Gothic', '나눔고딕', '맑은 고딕', sans-serif" },
        { label: '나눔명조', value: "'Nanum Myeongjo', '나눔명조', '바탕', serif" },
        { label: '맑은 고딕', value: "'맑은 고딕', 'Malgun Gothic', sans-serif" },
    ];
    public fontSizeOptions = FONT_SIZE_OPTIONS;
    public currentFontFamily: string = DOC_GULIM_FONT_FAMILY;
    public currentFontSize: string = DEFAULT_DOC_FONT_SIZE;
    public currentColor: string = DEFAULT_DOC_TEXT_COLOR;
    public currentBgColor: string = DEFAULT_DOC_HIGHLIGHT_COLOR;
    public currentTextAlign: string = DEFAULT_DOC_TEXT_ALIGN;
    public showDownloadMenu: boolean = false;
    public documentHtml: SafeHtml = '';
    public previewHtml: SafeHtml = '';
    public editorPages: number[] = [0];
    public previewPages: number[] = [0];
    public editorPageStackHeight: string = '297mm';
    public previewPageStackHeight: string = '297mm';
    public formatState: any = {
        bold: false,
        italic: false,
        underline: false,
        strikeThrough: false,
        orderedList: false,
        unorderedList: false,
    };

    private defaultDocumentStyle = {
        fontFamily: DOC_GULIM_FONT_FAMILY,
        fontSize: DEFAULT_DOC_FONT_SIZE,
        textColor: DEFAULT_DOC_TEXT_COLOR,
        backgroundColor: DEFAULT_DOC_HIGHLIGHT_COLOR,
        textAlign: DEFAULT_DOC_TEXT_ALIGN,
        lineHeight: DEFAULT_DOC_LINE_HEIGHT,
    };
    private fieldsMap: any = {};
    private activeRichTextElement: HTMLElement | null = null;
    private savedSelectionRange: Range | null = null;
    private toolbarRenderQueued: boolean = false;
    private pageMeasureFrame: number | null = null;
    private selectionChangeHandler = () => {
        if (this.currentStep !== 2) {
            return;
        }
        this.syncToolbarStateFromSelection();
        this.queueToolbarRender();
    };

    @ViewChild('docContainer') docContainer: ElementRef;
    @ViewChild('previewContainer') previewContainer: ElementRef;

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        document.addEventListener('selectionchange', this.selectionChangeHandler);

        this.templateId = WizRoute.segment.template_id || '';
        const urlParams = new URLSearchParams(window.location.search);
        this.docId = urlParams.get('doc_id') || '';

        this.authorName = this.service.auth.session?.name || '';

        await this.loadOptions();
        await this.loadCategories();
        await this.loadTemplate();
    }

    ngOnDestroy() {
        document.removeEventListener('selectionchange', this.selectionChangeHandler);
        if (this.pageMeasureFrame !== null) {
            cancelAnimationFrame(this.pageMeasureFrame);
            this.pageMeasureFrame = null;
        }
    }

    // ── Data Loading ──
    public async loadOptions() {
        const res = await wiz.call("get_options");
        if (res.code === 200) {
            this.options = res.data.data || this.options;
            if (this.options.departments?.length && !this.department) {
                this.department = this.options.departments[0];
            }
            if (this.options.org_codes?.length && !this.orgCode) {
                this.orgCode = this.options.org_codes[0];
            }
        }
    }

    public async loadCategories() {
        const res = await wiz.call("get_categories");
        if (res.code === 200) {
            this.categories = res.data.data || [];
        }
    }

    public async loadTemplate() {
        this.loading = true;
        await this.service.render();

        try {
            const res = await wiz.call("get_template", { template_id: this.templateId });
            if (res.code === 200) {
                this.template = res.data.data;
                this.fields = (this.template.fields_schema || []).filter((field: any) => field?.key !== 'attachments');
                this.fieldsMap = {};
                for (const f of this.fields) {
                    this.fieldsMap[f.key] = f;
                }
                this.initFormData();
            } else {
                await this.service.modal.error('오류', res.data?.message || '양식을 불러올 수 없습니다.');
                this.service.href('/docs');
                return;
            }

            if (this.docId) {
                const docRes = await wiz.call("get_document", { doc_id: this.docId });
                if (docRes.code === 200) {
                    const doc = docRes.data.data;
                    this.docTitle = doc.title || '';
                    this.formData = doc.form_data || {};
                    this.selectedCategory = doc.doc_category || '';
                    this.docNumber = doc.doc_number || '';
                    this.department = doc.department || this.department;
                    this.orgCode = doc.org_code || this.orgCode;
                    this.docType = doc.doc_type || this.docType;
                    this.recipient = doc.recipient || '';
                    this.via = doc.via || '';
                    this.execDate = doc.exec_date || '';
                    this.docGrade = doc.doc_grade || '일반';
                    this.publicity = doc.publicity || '공개';
                    this.recordType = doc.record_type || '전자';
                    // doc_handling
                    const handling = doc.doc_handling || [];
                    this.docHandling = {};
                    if (Array.isArray(handling)) {
                        for (const h of handling) this.docHandling[h] = true;
                    }
                }
            }

            if (!this.execDate) {
                this.execDate = new Date().toISOString().split('T')[0];
            }
            if (!this.selectedCategory && this.department) {
                this.selectedCategory = this.department;
            }

            this.syncTopMetaFormData();
            this.initApprovalLines();
            this.initDocumentStyle();
        } catch (e) {
            console.error('loadTemplate error:', e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public initFormData() {
        for (const field of this.fields) {
            if (!(field.key in this.formData)) {
                if (field.type === 'checkbox') {
                    this.formData[field.key] = field.default || false;
                } else {
                    this.formData[field.key] = field.default || '';
                }
            }
        }
    }

    private getDocumentKind(): string {
        const templateName = String(this.template?.name || '').trim();
        for (const kind of Object.keys(DOC_KIND_TEMPLATES)) {
            if ((DOC_KIND_TEMPLATES[kind] || []).includes(templateName)) {
                return kind;
            }
        }
        return 'official';
    }

    private getDefaultDocumentStyle() {
        const kind = this.getDocumentKind();
        return {
            ...this.defaultDocumentStyle,
            ...(DOCUMENT_STYLE_PRESETS[kind] || DOCUMENT_STYLE_PRESETS.official || {}),
        };
    }

    private getDefaultPageLayout() {
        const kind = this.getDocumentKind();
        return {
            ...DEFAULT_PAGE_LAYOUT,
            ...(PAGE_LAYOUT_PRESETS[kind] || {}),
        };
    }

    private getPageLayout() {
        return {
            ...this.getDefaultPageLayout(),
            ...(this.formData._page_layout || {}),
        };
    }

    private initPageLayout() {
        this.formData._page_layout = this.getPageLayout();
    }

    private normalizeFontFamily(value: any): string {
        const fontFamily = String(value || '').trim();
        if (!fontFamily) {
            return DOC_GULIM_FONT_FAMILY;
        }

        if (fontFamily.includes('SeasonDocumentGulim')) {
            return DOC_GULIM_FONT_FAMILY;
        }

        if (fontFamily.includes('SeasonDocumentDotum')) {
            return DOC_DOTUM_FONT_FAMILY;
        }

        if (fontFamily.includes('SeasonDocumentBatang')) {
            return DOC_BATANG_FONT_FAMILY;
        }

        if (fontFamily.includes('Nanum Myeongjo') || fontFamily.includes('나눔명조')) {
            return fontFamily;
        }

        if (fontFamily.includes('Nanum Gothic') || fontFamily.includes('나눔고딕')) {
            return fontFamily;
        }

        if (fontFamily.includes('Malgun Gothic') || fontFamily.includes('맑은 고딕')) {
            return fontFamily;
        }

        if (fontFamily.includes('돋움') || fontFamily.includes('Dotum')) {
            return DOC_DOTUM_FONT_FAMILY;
        }

        if (fontFamily.includes('바탕') || fontFamily.includes('Batang')) {
            return DOC_BATANG_FONT_FAMILY;
        }

        if (fontFamily.includes('굴림') || fontFamily.includes('Gulim')) {
            return DOC_GULIM_FONT_FAMILY;
        }

        return fontFamily;
    }

    private normalizeFontSize(value: any): string {
        const matched = String(value || '').trim().match(/(\d+(?:\.\d+)?)\s*pt/i);
        if (!matched) {
            return this.defaultDocumentStyle.fontSize;
        }
        return `${matched[1]}pt`;
    }

    private normalizeComputedFontSize(value: any, fallback: string): string {
        const raw = String(value || '').trim();
        if (!raw) {
            return fallback;
        }

        if (/pt$/i.test(raw)) {
            return this.normalizeFontSize(raw);
        }

        const pxMatched = raw.match(/(\d+(?:\.\d+)?)\s*px/i);
        if (!pxMatched) {
            return fallback;
        }

        const pointValue = parseFloat(pxMatched[1]) * 72 / 96;
        let closest = this.fontSizeOptions[0]?.value || fallback;
        let closestGap = Number.POSITIVE_INFINITY;
        for (const option of this.fontSizeOptions) {
            const gap = Math.abs(parseFloat(option.value) - pointValue);
            if (gap < closestGap) {
                closestGap = gap;
                closest = option.value;
            }
        }
        return closest;
    }

    private normalizeColor(value: any, fallback: string): string {
        const color = String(value || '').trim();
        if (/^#[0-9a-fA-F]{6}$/.test(color)) {
            return color.toLowerCase();
        }
        if (/^#[0-9a-fA-F]{3}$/.test(color)) {
            return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`.toLowerCase();
        }
        return fallback;
    }

    private parseCssColor(value: any): string | null {
        const color = String(value || '').trim();
        if (!color) {
            return null;
        }

        if (color === 'transparent' || color === 'rgba(0, 0, 0, 0)' || color === 'rgba(0,0,0,0)') {
            return null;
        }

        if (/^#[0-9a-fA-F]{6}$/.test(color)) {
            return color.toLowerCase();
        }

        if (/^#[0-9a-fA-F]{3}$/.test(color)) {
            return `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`.toLowerCase();
        }

        const rgbMatched = color.match(/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
        if (!rgbMatched) {
            return null;
        }

        return `#${Number(rgbMatched[1]).toString(16).padStart(2, '0')}${Number(rgbMatched[2]).toString(16).padStart(2, '0')}${Number(rgbMatched[3]).toString(16).padStart(2, '0')}`;
    }

    private normalizeTextAlign(value: any): string {
        const align = String(value || '').trim().toLowerCase();
        if (['left', 'center', 'right', 'justify'].includes(align)) {
            return align;
        }
        return this.defaultDocumentStyle.textAlign;
    }

    private getLegacyFontSizeValue(value: string): string {
        const normalized = this.normalizeFontSize(value);
        const match = this.fontSizeOptions.find((option: any) => option.value === normalized);
        return match?.legacy || '3';
    }

    private getFontSizeValueFromLegacy(value: any): string {
        const legacy = String(value || '').trim();
        const match = this.fontSizeOptions.find((option: any) => option.legacy === legacy);
        return match?.value || this.defaultDocumentStyle.fontSize;
    }

    private extractPrimaryFontName(fontFamily: string): string {
        const matched = String(fontFamily || '').match(/'([^']+)'|"([^"]+)"|([^,]+)/);
        return String(matched?.[1] || matched?.[2] || matched?.[3] || '').trim();
    }

    private getSelection(): Selection | null {
        return typeof window !== 'undefined' ? window.getSelection() : null;
    }

    private getRichTextElementFromNode(node: Node | null): HTMLElement | null {
        if (!node || !this.docContainer?.nativeElement) {
            return null;
        }

        const element = node instanceof HTMLElement ? node : node.parentElement;
        if (!element) {
            return null;
        }

        const richTextElement = element.closest('.doc-field-richtext') as HTMLElement | null;
        if (!richTextElement || !this.docContainer.nativeElement.contains(richTextElement)) {
            return null;
        }

        return richTextElement;
    }

    private rememberCurrentSelection(): boolean {
        const selection = this.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return false;
        }

        const richTextElement = this.getRichTextElementFromNode(selection.anchorNode)
            || this.getRichTextElementFromNode(selection.focusNode);
        if (!richTextElement) {
            return false;
        }

        this.activeRichTextElement = richTextElement;
        this.savedSelectionRange = selection.getRangeAt(0).cloneRange();
        return true;
    }

    private restoreRememberedSelection(): boolean {
        if (!this.savedSelectionRange || !this.activeRichTextElement || !this.docContainer?.nativeElement?.contains(this.activeRichTextElement)) {
            return false;
        }

        const selection = this.getSelection();
        if (!selection) {
            return false;
        }

        this.activeRichTextElement.focus();
        selection.removeAllRanges();
        selection.addRange(this.savedSelectionRange.cloneRange());
        return true;
    }

    private focusActiveRichText(): boolean {
        if (this.restoreRememberedSelection()) {
            return true;
        }

        const fallback = this.activeRichTextElement || this.docContainer?.nativeElement?.querySelector('.doc-field-richtext');
        if (!fallback) {
            return false;
        }

        const selection = this.getSelection();
        if (!selection) {
            return false;
        }

        fallback.focus();
        const range = document.createRange();
        range.selectNodeContents(fallback);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
        this.activeRichTextElement = fallback as HTMLElement;
        this.savedSelectionRange = range.cloneRange();
        return true;
    }

    private hasSelectionInRichText(): boolean {
        const selection = this.getSelection();
        if (!selection || selection.rangeCount === 0) {
            return false;
        }

        const richTextElement = this.getRichTextElementFromNode(selection.anchorNode)
            || this.getRichTextElementFromNode(selection.focusNode);
        return !!(richTextElement && !selection.getRangeAt(0).collapsed);
    }

    private hasRichTextContext(): boolean {
        const selection = this.getSelection();
        return !!(
            this.activeRichTextElement
            || this.getRichTextElementFromNode(selection?.anchorNode || null)
            || this.getRichTextElementFromNode(selection?.focusNode || null)
        );
    }

    private getActiveRichTextElement(): HTMLElement | null {
        const selection = this.getSelection();
        const richTextElement = this.getRichTextElementFromNode(selection?.anchorNode || null)
            || this.getRichTextElementFromNode(selection?.focusNode || null)
            || this.activeRichTextElement;
        if (richTextElement && this.docContainer?.nativeElement?.contains(richTextElement)) {
            this.activeRichTextElement = richTextElement;
            return richTextElement;
        }
        return null;
    }

    private selectActiveRichTextContents() {
        const richTextElement = this.getActiveRichTextElement();
        const selection = this.getSelection();
        if (!richTextElement || !selection) {
            return;
        }

        const range = document.createRange();
        range.selectNodeContents(richTextElement);
        selection.removeAllRanges();
        selection.addRange(range);
        this.savedSelectionRange = range.cloneRange();
    }

    private getPlainTextFromHtml(value: any): string {
        const container = document.createElement('div');
        container.innerHTML = String(value || '');
        return (container.textContent || '').trim();
    }

    private collectRichTextElementData(element: HTMLElement) {
        const metaField = element.getAttribute('data-meta-field');
        if (metaField === 'title') {
            this.formData._meta_title_html = this.normalizeRichTextHtml(element.innerHTML);
            this.docTitle = (element.textContent || '').trim();
            return;
        }
        if (metaField === 'recipient') {
            this.recipient = (element.textContent || '').trim();
            return;
        }
        if (metaField === 'reference') {
            this.via = (element.textContent || '').trim();
            return;
        }

        const bottomField = element.getAttribute('data-bottom-field');
        if (bottomField === 'approval_freeform') {
            this.formData._approval_line_html = this.normalizeRichTextHtml(element.innerHTML);
            return;
        }

        const key = element.getAttribute('data-field-key');
        if (key) {
            this.formData[key] = this.normalizeRichTextHtml(element.innerHTML);
            const plainText = (element.textContent || '').trim();
            if (key === 'title') {
                this.docTitle = plainText;
            }
            if (key === 'receiver_org' || key === 'report_to') {
                this.recipient = plainText;
            }
            if (key === 'reference' || key === 'via') {
                this.via = plainText;
            }
        }
    }

    private getEffectiveBackgroundColor(element: HTMLElement | null, fallback: string): string {
        let current: HTMLElement | null = element;
        while (current && this.activeRichTextElement?.contains(current)) {
            const color = this.parseCssColor(window.getComputedStyle(current).backgroundColor);
            if (color) {
                return color;
            }
            current = current.parentElement;
        }
        return fallback;
    }

    private queueToolbarRender() {
        if (this.toolbarRenderQueued) {
            return;
        }
        this.toolbarRenderQueued = true;
        requestAnimationFrame(() => {
            this.toolbarRenderQueued = false;
            void this.service.render();
        });
    }

    private syncToolbarStateFromSelection() {
        const docStyle = this.getDocumentStyle();
        let fontFamily = docStyle.fontFamily;
        let fontSize = docStyle.fontSize;
        let textColor = docStyle.textColor;
        let backgroundColor = docStyle.backgroundColor;
        let textAlign = docStyle.textAlign;
        const nextFormatState = {
            bold: false,
            italic: false,
            underline: false,
            strikeThrough: false,
            orderedList: false,
            unorderedList: false,
        };

        const selection = this.getSelection();
        const richTextElement = this.getRichTextElementFromNode(selection?.anchorNode || null)
            || this.getRichTextElementFromNode(selection?.focusNode || null)
            || this.activeRichTextElement;

        if (richTextElement && (!this.docContainer || this.docContainer.nativeElement.contains(richTextElement))) {
            this.activeRichTextElement = richTextElement;
            const referenceElement = (selection?.focusNode instanceof HTMLElement ? selection.focusNode : selection?.focusNode?.parentElement)
                || (selection?.anchorNode instanceof HTMLElement ? selection.anchorNode : selection?.anchorNode?.parentElement)
                || richTextElement;
            const blockElement = referenceElement.closest('p, div, li, td, th') as HTMLElement | null;
            const computedStyle = window.getComputedStyle(referenceElement);
            const blockStyle = window.getComputedStyle(blockElement || richTextElement);

            fontFamily = this.normalizeFontFamily(computedStyle.fontFamily || docStyle.fontFamily);
            fontSize = this.normalizeComputedFontSize(computedStyle.fontSize, docStyle.fontSize);
            textColor = this.parseCssColor(computedStyle.color) || docStyle.textColor;
            backgroundColor = this.getEffectiveBackgroundColor(referenceElement, docStyle.backgroundColor);
            textAlign = this.normalizeTextAlign(blockStyle.textAlign || docStyle.textAlign);

            const commandMap: any = {
                bold: 'bold',
                italic: 'italic',
                underline: 'underline',
                strikeThrough: 'strikeThrough',
                orderedList: 'insertOrderedList',
                unorderedList: 'insertUnorderedList',
            };
            for (const [stateKey, command] of Object.entries(commandMap)) {
                try {
                    nextFormatState[stateKey] = document.queryCommandState(command);
                } catch (e) {
                    nextFormatState[stateKey] = false;
                }
            }
        }

        this.currentFontFamily = fontFamily;
        this.currentFontSize = fontSize;
        this.currentColor = textColor;
        this.currentBgColor = backgroundColor;
        this.currentTextAlign = textAlign;
        this.formatState = nextFormatState;
    }

    private normalizeRichTextHtml(value: any): string {
        const html = String(value || '');
        if (!html) {
            return '';
        }

        const container = document.createElement('div');
        container.innerHTML = html;

        container.querySelectorAll('font').forEach((fontElement: Element) => {
            const span = document.createElement('span');
            const fontFace = fontElement.getAttribute('face');
            const fontSize = fontElement.getAttribute('size');
            const fontColor = fontElement.getAttribute('color');
            const styleText = fontElement.getAttribute('style');

            if (fontFace) {
                span.style.fontFamily = this.normalizeFontFamily(fontFace);
            }
            if (fontSize) {
                span.style.fontSize = this.getFontSizeValueFromLegacy(fontSize);
            }
            if (fontColor) {
                span.style.color = this.normalizeColor(fontColor, this.defaultDocumentStyle.textColor);
            }
            if (styleText) {
                span.setAttribute('style', `${styleText}; ${span.getAttribute('style') || ''}`);
            }

            while (fontElement.firstChild) {
                span.appendChild(fontElement.firstChild);
            }
            fontElement.replaceWith(span);
        });

        container.querySelectorAll('[style]').forEach((element: Element) => {
            const styleElement = element as HTMLElement;
            if (styleElement.style.fontFamily) {
                styleElement.style.fontFamily = this.normalizeFontFamily(styleElement.style.fontFamily);
            }
            if (styleElement.style.fontSize) {
                styleElement.style.fontSize = this.normalizeComputedFontSize(styleElement.style.fontSize, this.defaultDocumentStyle.fontSize);
            }
            if (styleElement.style.color) {
                const color = this.parseCssColor(styleElement.style.color);
                if (color) {
                    styleElement.style.color = color;
                }
            }
            if (styleElement.style.backgroundColor) {
                const backgroundColor = this.parseCssColor(styleElement.style.backgroundColor);
                if (backgroundColor) {
                    styleElement.style.backgroundColor = backgroundColor;
                } else {
                    styleElement.style.removeProperty('background-color');
                }
            }
            if (styleElement.style.textAlign) {
                styleElement.style.textAlign = this.normalizeTextAlign(styleElement.style.textAlign);
            }

            // 외부에서 붙여넣은 hanging-indent / 들여쓰기 스타일 제거
            // (HWP/Word: margin-left:14.9pt; text-indent:-4.9pt; padding-left:X 등)
            styleElement.style.removeProperty('text-indent');
            styleElement.style.removeProperty('padding-left');
            styleElement.style.removeProperty('margin-left');
        });

        return container.innerHTML;
    }

    private executeEditorCommand(command: string, value?: string, wholeActiveFieldWhenCollapsed: boolean = false): boolean {
        if (!this.focusActiveRichText()) {
            return false;
        }

        const selection = this.getSelection();
        if (wholeActiveFieldWhenCollapsed && selection?.rangeCount && selection.getRangeAt(0).collapsed) {
            this.selectActiveRichTextContents();
        }

        try {
            document.execCommand(command, false, value || '');
        } catch (e) {
            return false;
        }

        this.rememberCurrentSelection();
        const activeRichTextElement = this.getActiveRichTextElement();
        if (activeRichTextElement) {
            this.collectRichTextElementData(activeRichTextElement);
        }
        this.collectRichTextData();
        this.syncToolbarStateFromSelection();
        return true;
    }

    public rememberToolbarSelection() {
        this.rememberCurrentSelection();
    }

    public handleToolbarMouseDown(event: MouseEvent) {
        this.rememberCurrentSelection();
        event.preventDefault();
    }

    private getDocumentStyle() {
        const defaults = this.getDefaultDocumentStyle();
        const raw = {
            ...defaults,
            ...(this.formData._doc_style || {}),
        };

        return {
            fontFamily: this.normalizeFontFamily(raw.fontFamily),
            fontSize: this.normalizeFontSize(raw.fontSize),
            textColor: this.normalizeColor(raw.textColor, defaults.textColor),
            backgroundColor: this.normalizeColor(raw.backgroundColor, defaults.backgroundColor),
            textAlign: this.normalizeTextAlign(raw.textAlign),
            lineHeight: String(raw.lineHeight || defaults.lineHeight),
        };
    }

    private syncDocumentStyleState(docStyle: any) {
        this.currentFontFamily = docStyle.fontFamily;
        this.currentFontSize = docStyle.fontSize;
        this.currentColor = docStyle.textColor;
        this.currentBgColor = docStyle.backgroundColor;
        this.currentTextAlign = docStyle.textAlign;
    }

    private setDocumentStyle(patch: any = {}) {
        const defaults = this.getDefaultDocumentStyle();
        const next = {
            ...this.getDocumentStyle(),
            ...patch,
        };

        const normalized = {
            fontFamily: this.normalizeFontFamily(next.fontFamily),
            fontSize: this.normalizeFontSize(next.fontSize),
            textColor: this.normalizeColor(next.textColor, defaults.textColor),
            backgroundColor: this.normalizeColor(next.backgroundColor, defaults.backgroundColor),
            textAlign: this.normalizeTextAlign(next.textAlign),
            lineHeight: String(next.lineHeight || defaults.lineHeight),
        };

        this.formData._doc_style = normalized;
        this.syncDocumentStyleState(normalized);
    }

    private applyDocumentStyleToLiveContainer() {
        if (!this.docContainer?.nativeElement) {
            return;
        }

        const docRoot = this.docContainer.nativeElement.querySelector('.doc-container') as HTMLElement | null;
        if (!docRoot) {
            return;
        }

        const docStyle = this.getDocumentStyle();
        docRoot.style.setProperty('--doc-font-family', docStyle.fontFamily);
        docRoot.style.setProperty('--doc-font-size', docStyle.fontSize);
        docRoot.style.setProperty('--doc-text-color', docStyle.textColor);
        docRoot.style.setProperty('--doc-background-color', docStyle.backgroundColor);
        docRoot.style.setProperty('--doc-text-align', docStyle.textAlign);
        docRoot.style.setProperty('--doc-line-height', docStyle.lineHeight);
        docRoot.style.fontFamily = 'var(--doc-font-family)';
        docRoot.style.fontSize = 'var(--doc-font-size)';
        docRoot.style.color = 'var(--doc-text-color)';
        docRoot.style.lineHeight = 'var(--doc-line-height)';
    }

    private initApprovalLines() {
        if (this.formData.approval_lines && this.formData.approval_lines.length > 0) {
            this.approvalLines = this.formData.approval_lines;
        } else {
            this.approvalLines = JSON.parse(JSON.stringify(this.defaultApprovalLines));
        }
    }

    private initDocumentStyle() {
        const docStyle = this.getDocumentStyle();
        this.formData._doc_style = docStyle;
        this.syncDocumentStyleState(docStyle);
        this.initPageLayout();
    }

    private mmToPx(mm: number): number {
        return mm * 96 / 25.4;
    }

    private getPageContentBottomPx(pageCount: number, pageHeightPx: number, marginTopPx: number, marginBottomPx: number): number {
        return (pageCount * pageHeightPx)
            + (Math.max(pageCount - 1, 0) * PAGE_GAP_PX)
            - marginTopPx
            - marginBottomPx;
    }

    private getPageCountForBottomAlignedHeight(requiredHeightPx: number, pageHeightPx: number, marginTopPx: number, marginBottomPx: number): number {
        let pageCount = 1;
        while (this.getPageContentBottomPx(pageCount, pageHeightPx, marginTopPx, marginBottomPx) < requiredHeightPx) {
            pageCount += 1;
        }
        return pageCount;
    }

    private alignBottomSectionToLastPage(docRoot: HTMLElement, layout: any, pageHeightPx: number, usableHeightPx: number): number {
        const bottomSection = docRoot.querySelector('.doc-bottom-section') as HTMLElement | null;
        if (!bottomSection) {
            const contentHeightPx = Math.max(docRoot.scrollHeight, docRoot.offsetHeight, Math.ceil(docRoot.getBoundingClientRect().height));
            return Math.max(1, Math.ceil(contentHeightPx / usableHeightPx));
        }

        bottomSection.style.marginTop = '';

        const marginTopPx = this.mmToPx(layout.marginTopMm);
        const marginBottomPx = this.mmToPx(layout.marginBottomMm);
        const bottomStyle = window.getComputedStyle(bottomSection);
        const minimumGapPx = parseFloat(bottomStyle.marginTop || '0') || 24;
        const docRootTopPx = docRoot.getBoundingClientRect().top;
        const bottomRect = bottomSection.getBoundingClientRect();
        const contentBeforeBottomPx = Math.max(0, Math.ceil(bottomRect.top - docRootTopPx - minimumGapPx));
        const bottomHeightPx = Math.ceil(bottomRect.height);
        const requiredHeightPx = contentBeforeBottomPx + minimumGapPx + bottomHeightPx;
        const pageCount = this.getPageCountForBottomAlignedHeight(requiredHeightPx, pageHeightPx, marginTopPx, marginBottomPx);
        const targetBottomPx = this.getPageContentBottomPx(pageCount, pageHeightPx, marginTopPx, marginBottomPx);
        const alignedGapPx = Math.max(minimumGapPx, Math.floor(targetBottomPx - contentBeforeBottomPx - bottomHeightPx));

        bottomSection.style.marginTop = `${alignedGapPx}px`;
        return pageCount;
    }

    private updatePagedCanvas(target: 'editor' | 'preview') {
        const host = target === 'editor' ? this.docContainer?.nativeElement : this.previewContainer?.nativeElement;
        if (!host) {
            return;
        }

        const docRoot = host.querySelector('.doc-container') as HTMLElement | null;
        if (!docRoot) {
            return;
        }

        const layout = this.getPageLayout();
        const usableHeightPx = this.mmToPx(layout.heightMm - layout.marginTopMm - layout.marginBottomMm);
        const pageHeightPx = this.mmToPx(layout.heightMm);
        host.style.setProperty('--page-width-mm', `${layout.widthMm}mm`);
        host.style.setProperty('--page-height-mm', `${layout.heightMm}mm`);
        host.style.setProperty('--page-margin-left-mm', `${layout.marginLeftMm}mm`);
        host.style.setProperty('--page-margin-right-mm', `${layout.marginRightMm}mm`);
        host.style.setProperty('--page-margin-top-mm', `${layout.marginTopMm}mm`);
        host.style.setProperty('--page-margin-bottom-mm', `${layout.marginBottomMm}mm`);
        host.style.setProperty('--page-gap-px', `${PAGE_GAP_PX}px`);

        const pageCount = this.alignBottomSectionToLastPage(docRoot, layout, pageHeightPx, usableHeightPx);
        const totalHeightPx = (pageCount * pageHeightPx) + (Math.max(pageCount - 1, 0) * PAGE_GAP_PX);
        const pages = Array.from({ length: pageCount }, (_value, index) => index);

        if (target === 'editor') {
            this.editorPages = pages;
            this.editorPageStackHeight = `${totalHeightPx}px`;
        } else {
            this.previewPages = pages;
            this.previewPageStackHeight = `${totalHeightPx}px`;
        }
    }

    private queuePageLayoutMeasure(target: 'editor' | 'preview' | 'both' = 'both') {
        if (typeof window === 'undefined') {
            return;
        }

        if (this.pageMeasureFrame !== null) {
            cancelAnimationFrame(this.pageMeasureFrame);
        }

        this.pageMeasureFrame = requestAnimationFrame(() => {
            this.pageMeasureFrame = null;
            if (target === 'editor' || target === 'both') {
                this.updatePagedCanvas('editor');
            }
            if (target === 'preview' || target === 'both') {
                this.updatePagedCanvas('preview');
            }
        });
    }

    // ── Step Navigation ──
    public async goToStep(step: number) {
        if (step === 2) {
            if (!this.docTitle) {
                await this.service.modal.error('알림', '문서 제목을 입력해주세요.');
                return;
            }
            this.buildDocumentHtml();
        }
        if (step === 3) {
            this.collectRichTextData();
            this.formData.approval_lines = [...this.approvalLines];
            this.buildPreviewHtml();
        }
        this.currentStep = step;
        await this.service.render();
        if (step === 2) {
            this.applyDocumentStyleToLiveContainer();
            this.syncToolbarStateFromSelection();
            this.queueToolbarRender();
            this.queuePageLayoutMeasure('editor');
        }
        if (step === 3) {
            this.queuePageLayoutMeasure('preview');
        }
        if (step === 2 || step === 3) {
            window.scrollTo(0, 0);
        }
    }

    // ── Doc Handling Checkbox ──
    public toggleDocHandling(option: string) {
        if (this.docHandling[option]) {
            delete this.docHandling[option];
        } else {
            this.docHandling[option] = true;
        }
        this.service.render();
    }

    public getDocHandlingArray(): string[] {
        return Object.keys(this.docHandling).filter(k => this.docHandling[k]);
    }

    public async toggleDownloadMenu(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (this.downloading) {
            return;
        }
        this.showDownloadMenu = !this.showDownloadMenu;
        await this.service.render();
    }

    public async selectDownloadFormat(format: string) {
        this.showDownloadMenu = false;
        await this.service.render();
        await this.download(format);
    }

    // ── Approval Lines ──
    public async addApprovalLine() {
        if (this.approvalLines.length >= 6) return;
        this.approvalLines.push({ label: '', name: '' });
        await this.service.render();
    }

    public async removeApprovalLine(index: number) {
        if (this.approvalLines.length <= 2) return;
        this.approvalLines.splice(index, 1);
        await this.service.render();
    }

    public onApprovalChange() {
        if (this.currentStep === 2) {
            this.collectRichTextData();
            this.formData.approval_lines = [...this.approvalLines];
            this.buildDocumentHtml();
            this.queuePageLayoutMeasure('editor');
        }
        this.service.render();
    }

    // ── Step 2: Document HTML ──
    private escapeHtml(str: string): string {
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\"/g, '&quot;');
    }

    private isRichEditableField(field: any): boolean {
        return ['text', 'textarea'].includes(String(field?.type || 'text'));
    }

    private buildRichEditableFieldHtml(key: string, value: any, placeholder: string, editable: boolean = true): string {
        const content = this.normalizeRichTextHtml(value || '');
        if (!editable) {
            return content || `<span style="color:#ccc;">(미입력)</span>`;
        }

        return `<span data-field-key="${key}" class="doc-field-input doc-field-richtext" contenteditable="true" data-placeholder="${placeholder}">${content}</span>`;
    }

    private getMetaTitleHtml(): string {
        const savedHtml = String(this.formData._meta_title_html || '').trim();
        if (savedHtml && this.getPlainTextFromHtml(savedHtml) === String(this.docTitle || '').trim()) {
            return this.normalizeRichTextHtml(savedHtml);
        }
        return this.escapeHtml(this.docTitle);
    }

    private buildMetaTitleHtml(editable: boolean = false): string {
        const content = this.getMetaTitleHtml();
        if (!editable) {
            return content;
        }
        return `<span data-meta-field="title" class="doc-field-input doc-field-richtext doc-meta-richtext" contenteditable="true" data-placeholder="제목">${content}</span>`;
    }

    private removeClassificationSectionHtml(html: string): string {
        return String(html || '').replace(/<div\b[^>]*class=(["'])[^"']*\bdoc-classify\b[^"']*\1[^>]*>[\s\S]*?<\/div>\s*/gi, '');
    }

    private removeAttachmentSectionHtml(html: string): string {
        return String(html || '')
            .replace(/\s*<div\b[^>]*class=(["'])[^"']*\bdoc-body\b[^"']*\1[^>]*>\s*<p\b[^>]*class=(["'])[^"']*\battach-title\b[^"']*\2[^>]*>[\s\S]*?<\/p>\s*<\/div>\s*/gi, '')
            .replace(/\s*<p\b[^>]*class=(["'])[^"']*\battach-title\b[^"']*\1[^>]*>[\s\S]*?<\/p>\s*/gi, '')
            .replace(/\s*<div\b[^>]*class=(["'])[^"']*\bdoc-attachments\b[^"']*\1[^>]*>[\s\S]*?<\/div>\s*/gi, '')
            .replace(/\s*<div\b[^>]*class=(["'])[^"']*\bdoc-section-title\b[^"']*\1[^>]*>[\s\S]*?(?:붙임|첨부(?:파일)?)[\s\S]*?<\/div>\s*<div\b[^>]*>\s*\{\{\s*attachments\s*\}\}\s*<\/div>\s*/gi, '')
            .replace(/\s*<tr\b[^>]*>[\s\S]*?(?:붙임|첨부(?:파일)?)[\s\S]*?\{\{\s*attachments\s*\}\}[\s\S]*?<\/tr>\s*/gi, '')
            .replace(/\s*<tr\b[^>]*>[\s\S]*?data-field-key=(["'])attachments\1[\s\S]*?<\/tr>\s*/gi, '');
    }

    private getTopRecipientKey(): string | null {
        if (this.fieldsMap.receiver_org) return 'receiver_org';
        if (this.fieldsMap.report_to) return 'report_to';
        return null;
    }

    private getTopReferenceKey(): string | null {
        if (this.fieldsMap.reference) return 'reference';
        if (this.fieldsMap.via) return 'via';
        return null;
    }

    private getFirstTopValue(keys: string[], fallback: any = ''): any {
        for (const key of keys) {
            const value = this.formData[key];
            if (value !== undefined && value !== null && String(value).trim()) {
                return value;
            }
        }
        return fallback || '';
    }

    private buildTopMetaValueHtml(fieldKey: string | null, metaField: string, value: any, placeholder: string, editable: boolean): string {
        if (editable) {
            if (fieldKey) {
                return this.buildRichEditableFieldHtml(fieldKey, value, placeholder, true);
            }
            const content = this.normalizeRichTextHtml(value || '');
            return `<span data-meta-field="${metaField}" class="doc-field-input doc-field-richtext doc-meta-richtext" contenteditable="true" data-placeholder="${placeholder}">${content}</span>`;
        }

        if (!value) {
            return `<span style="color:#ccc;">(미입력)</span>`;
        }
        return this.normalizeRichTextHtml(value);
    }

    private buildTopMetaSectionHtml(editable: boolean): string {
        const recipientKey = this.getTopRecipientKey();
        const referenceKey = this.getTopReferenceKey();
        const recipient = this.getFirstTopValue(['receiver_org', 'report_to'], this.recipient);
        const reference = this.getFirstTopValue(['reference', 'via'], this.via);
        const title = this.getFirstTopValue(['title'], this.getMetaTitleHtml());
        const recipientHtml = this.buildTopMetaValueHtml(recipientKey, 'recipient', recipient, '수신', editable);
        const referenceHtml = this.buildTopMetaValueHtml(referenceKey, 'reference', reference, '참조', editable);
        const titleHtml = this.buildTopMetaValueHtml(this.fieldsMap.title ? 'title' : null, 'title', title, '제목', editable);

        return `
<div class="doc-field-row doc-top-meta-row">
    <span class="doc-field-label"><span class="doc-field-label-colored">수신</span></span>
    <span class="doc-field-value">${recipientHtml}</span>
</div>
<div class="doc-field-row doc-top-meta-row">
    <span class="doc-field-label"><span class="doc-field-label-colored">참조</span></span>
    <span class="doc-field-value">${referenceHtml}</span>
</div>
<div class="doc-field-row doc-subject-row doc-top-meta-row">
    <span class="doc-field-label"><span class="doc-field-label-colored">제목</span></span>
    <span class="doc-field-value">${titleHtml}</span>
</div>`;
    }

    private normalizeTopMetaSectionHtml(html: string, editable: boolean): string {
        const classificationPattern = /<div\b[^>]*class=(["'])[^"']*\bdoc-classify\b[^"']*\1[^>]*>/i;
        const topRowPattern = /(?:\s*<div\b[^>]*class=(["'])[^"']*\bdoc-(?:field-row|subject-row)\b[^"']*\1[^>]*>[\s\S]*?<\/div>)+/i;
        const hadClassification = classificationPattern.test(html);
        let normalized = this.removeClassificationSectionHtml(html);
        if (!hadClassification && !topRowPattern.test(normalized)) {
            return normalized;
        }

        const topMetaHtml = this.buildTopMetaSectionHtml(editable);
        if (topRowPattern.test(normalized)) {
            return normalized.replace(topRowPattern, `\n${topMetaHtml}\n`);
        }

        if (hadClassification) {
            const headerGapPattern = /(<div\b[^>]*class=(["'])[^"']*\bdoc-header-gap\b[^"']*\2[^>]*>\s*<\/div>\s*)/i;
            if (headerGapPattern.test(normalized)) {
                return normalized.replace(headerGapPattern, `$1\n${topMetaHtml}\n`);
            }
        }

        return normalized;
    }

    private syncTopMetaFormData() {
        if (!this.formData) return;
        const recipientKey = this.getTopRecipientKey();
        if (recipientKey && !String(this.formData[recipientKey] || '').trim() && this.recipient) {
            this.formData[recipientKey] = this.recipient;
        }
        const referenceKey = this.getTopReferenceKey();
        if (referenceKey && !String(this.formData[referenceKey] || '').trim() && this.via) {
            this.formData[referenceKey] = this.via;
        }
        if (this.fieldsMap.title && !String(this.formData.title || '').trim() && this.docTitle) {
            this.formData.title = this.docTitle;
        }
    }

    public buildDocumentHtml() {
        this.syncTopMetaFormData();
        let html = this.template?.template_content || '';
        if (!html) {
            this.documentHtml = this.sanitizer.bypassSecurityTrustHtml('<div style="padding:60px;text-align:center;color:#999;">서식 레이아웃이 없습니다.</div>');
            return;
        }
        html = this.normalizeTopMetaSectionHtml(html, true);
        html = this.removeAttachmentSectionHtml(html);

        html = html.replace(/\{\{(\w+)\}\}/g, (match: string, key: string) => {
            const field = this.fieldsMap[key];
            if (!field) return match;
            const val = this.formData[key] ?? field.default ?? '';
            const ph = this.escapeHtml(field.label || key);
            const cls = 'doc-field-input';
            switch (field.type) {
                case 'text':
                case 'textarea':
                    return this.buildRichEditableFieldHtml(key, val, ph, true);
                case 'select': {
                    const opts = (field.options || []).map((o: string) => {
                        const selected = (String(val) === o) ? ' selected' : '';
                        return `<option value="${this.escapeHtml(o)}"${selected}>${this.escapeHtml(o)}</option>`;
                    }).join('');
                    return `<select data-field-key="${key}" class="${cls} doc-field-select"><option value="">-- ${ph} --</option>${opts}</select>`;
                }
                case 'checkbox': {
                    const checked = val ? ' checked' : '';
                    return `<label class="doc-field-checkbox-label"><input type="checkbox" data-field-key="${key}" class="doc-field-checkbox"${checked}/> ${ph}</label>`;
                }
                case 'date':
                    return `<input type="date" data-field-key="${key}" class="${cls}" value="${this.escapeHtml(String(val))}" placeholder="${ph}" />`;
                case 'number':
                    return `<input type="number" data-field-key="${key}" class="${cls}" value="${this.escapeHtml(String(val))}" placeholder="${ph}" />`;
                default:
                    return `<input type="text" data-field-key="${key}" class="${cls}" value="${this.escapeHtml(String(val))}" placeholder="${ph}" />`;
            }
        });

        html = this.replaceBottomSectionHtml(html, true);

        // 메타 기반 동적 치환 (수신, 제목 등)
        html = html.replace(/\{\{META_RECIPIENT\}\}/g, this.escapeHtml(this.recipient));
        html = html.replace(/\{\{META_VIA\}\}/g, this.escapeHtml(this.via));
        html = html.replace(/\{\{META_TITLE\}\}/g, this.buildMetaTitleHtml(true));
        html = html.replace(/\{\{META_DEPARTMENT\}\}/g, this.escapeHtml(this.department));
        html = html.replace(/\{\{META_DOCNUMBER\}\}/g, this.docNumber || '(자동)');
        html = html.replace(/\{\{META_EXEC_DATE\}\}/g, this.escapeHtml(this.execDate));
        html = html.replace(/\{\{META_DOC_GRADE\}\}/g, this.escapeHtml(this.docGrade));
        html = html.replace(/\{\{META_PUBLICITY\}\}/g, this.escapeHtml(this.publicity));

        html = this.applyDocumentStyleToHtml(html);
        this.documentHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    }

    private applyDocumentStyleToHtml(html: string): string {
        const docStyle = this.getDocumentStyle();
        const docKind = this.getDocumentKind();
        const docKindClass = `doc-kind-${docKind}`;
        const styleText = [
            `--doc-font-family: ${docStyle.fontFamily}`,
            `--doc-font-size: ${docStyle.fontSize}`,
            `--doc-text-color: ${docStyle.textColor}`,
            `--doc-background-color: ${docStyle.backgroundColor}`,
            `--doc-text-align: ${docStyle.textAlign}`,
            `--doc-line-height: ${docStyle.lineHeight}`,
            'font-family: var(--doc-font-family)',
            'font-size: var(--doc-font-size)',
            'color: var(--doc-text-color)',
            'line-height: var(--doc-line-height)',
        ].join('; ');
        if (!html.includes('doc-container')) {
            return `<div class="doc-container ${docKindClass}" data-doc-kind="${docKind}" style="${styleText}">${html}</div>`;
        }
        return html.replace(/<div([^>]*class="[^"]*doc-container[^"]*"[^>]*)>/, (match: string, attrs: string) => {
            let nextAttrs = attrs;
            const classMatch = nextAttrs.match(/class="([^"]*)"/);
            if (classMatch && !classMatch[1].split(/\s+/).includes(docKindClass)) {
                nextAttrs = nextAttrs.replace(/class="([^"]*)"/, `class="${classMatch[1]} ${docKindClass}"`);
            }
            if (!/\sdata-doc-kind=/.test(nextAttrs)) {
                nextAttrs = `${nextAttrs} data-doc-kind="${docKind}"`;
            }
            const styleMatch = nextAttrs.match(/style="([^"]*)"/);
            if (styleMatch) {
                const mergedStyle = `${styleMatch[1]}; ${styleText}`;
                return `<div${nextAttrs.replace(/style="([^"]*)"/, `style="${mergedStyle}"`)}>`;
            }
            return `<div${nextAttrs} style="${styleText}">`;
        });
    }

    private replaceBottomSectionHtml(html: string, editable: boolean = false): string {
        const bottomSectionHtml = this.buildApprovalSectionHtml(editable);
        const withoutLegacyFooter = html.replace(/<div class="doc-footer">[\s\S]*?<\/table>\s*<\/div>/, '');
        return withoutLegacyFooter.replace('<!-- APPROVAL_SECTION -->', bottomSectionHtml);
    }

    private formatBottomDate(value: string): string {
        if (!value) return '';
        const match = String(value).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!match) return `(${this.escapeHtml(String(value).trim())})`;
        return `(${match[1]}. ${match[2]}. ${match[3]}.)`;
    }

    private getFooterDocNumberDisplay(): string {
        if (this.formData._footer_doc_number) {
            return this.formData._footer_doc_number;
        }
        if (this.docNumber) {
            return this.orgCode ? `${this.orgCode}-${this.docNumber}` : this.docNumber;
        }
        return '(저장 시 자동발급)';
    }

    private getFooterRecipientDisplay(): string {
        return this.formData._footer_recipient || this.recipient || this.formData.receiver_org || this.formData.report_to || '';
    }

    private getFooterEmail(): string {
        return this.formData._footer_email || this.formData.contact_email || this.formData.drafter_email || this.formData.email || this.companyInfo.email || '';
    }

    private getFooterDraftDateDisplay(): string {
        if (this.formData._footer_draft_date) {
            return this.formData._footer_draft_date;
        }
        return this.formatBottomDate(this.execDate || this.formData.draft_date || '');
    }

    private getFooterReceiptDisplay(): string {
        return this.formData._footer_receipt || '';
    }

    private getFooterCollaboratorDisplay(): string {
        return this.formData._collaborator || '';
    }

    private getFooterZipDisplay(): string {
        return this.formData._footer_zip || this.companyInfo.zip;
    }

    private getFooterAddressDisplay(): string {
        return this.formData._footer_address || this.companyInfo.address;
    }

    private getFooterWebsiteDisplay(): string {
        return this.formData._footer_website || this.companyInfo.website;
    }

    private getFooterPhoneDisplay(): string {
        return this.formData._footer_phone || this.companyInfo.phone;
    }

    private getFooterFaxDisplay(): string {
        return this.formData._footer_fax || this.companyInfo.fax;
    }

    private buildDefaultApprovalLineHtml(): string {
        const parts = (this.approvalLines || [])
            .filter((line: any) => (line.label || '').trim() || (line.name || '').trim())
            .map((line: any) => `${this.escapeHtml((line.label || '').trim())}&nbsp;&nbsp;${this.escapeHtml((line.name || '').trim())}`);

        if (parts.length === 0) {
            return '담당&nbsp;&nbsp;&nbsp;&nbsp;센터장&nbsp;&nbsp;&nbsp;&nbsp;대표이사';
        }

        return parts.join('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
    }

    private getApprovalLineHtml(): string {
        const saved = String(this.formData._approval_line_html || '').trim();
        if (!saved) {
            return this.buildDefaultApprovalLineHtml();
        }
        return this.normalizeRichTextHtml(saved);
    }

    private buildApprovalSectionHtml(editable: boolean = false): string {
        const ce = editable ? ' contenteditable="true"' : '';

        const recipient = this.getFooterRecipientDisplay();
        const docNumber = this.getFooterDocNumberDisplay();
        const draftDate = this.getFooterDraftDateDisplay();
        const email = this.getFooterEmail();
        const collaborator = this.getFooterCollaboratorDisplay();
        const receipt = this.getFooterReceiptDisplay();
        const zip = this.getFooterZipDisplay();
        const address = this.getFooterAddressDisplay();
        const website = this.getFooterWebsiteDisplay();
        const phone = this.getFooterPhoneDisplay();
        const fax = this.getFooterFaxDisplay();
        const approvalLineHtml = this.getApprovalLineHtml();

        const FIXED_STYLE = "font-family: 'SeasonDocumentGulim', '굴림체', GulimChe, '굴림', Gulim, sans-serif; color: #000;";

        return `
<div class="doc-bottom-section" style="${FIXED_STYLE} font-size: 8pt; line-height: 1.5;">
    <div class="doc-bottom-title" style="${FIXED_STYLE} font-size: 15pt; font-weight: 700; line-height: 1.25;">${this.companyInfo.name} ${this.companyInfo.ceo}</div>
    <div class="doc-bottom-recipient-row">
        <span class="doc-bottom-recipient-row__label">수신자</span>
        <span class="doc-bottom-recipient-row__value"${ce} data-bottom-field="recipient">${this.escapeHtml(recipient)}</span>
    </div>
    <div class="doc-bottom-divider"></div>
    <div class="doc-bottom-approval-freeform doc-field-richtext"${ce} data-bottom-field="approval_freeform" data-placeholder="결재라인을 자유롭게 입력하세요">${approvalLineHtml}</div>
    <div class="doc-bottom-helper-row">
        <span class="doc-bottom-helper-row__label">협조자</span>
        <span class="doc-bottom-helper-row__value"${ce} data-bottom-field="collaborator">${this.escapeHtml(collaborator)}</span>
    </div>
    <div class="doc-bottom-info-row doc-bottom-info-row--issue">
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">시행</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="doc_number">${this.escapeHtml(docNumber)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value doc-bottom-info-cell--date"${ce} data-bottom-field="draft_date">${this.escapeHtml(draftDate)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">접수</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="receipt">${this.escapeHtml(receipt)}</span>
    </div>
    <div class="doc-bottom-info-row doc-bottom-info-row--address">
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">우</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="zip">${this.escapeHtml(zip)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="address">${this.escapeHtml(address)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value doc-bottom-info-cell--website"${ce} data-bottom-field="website">${this.escapeHtml(website)}</span>
    </div>
    <div class="doc-bottom-info-row doc-bottom-info-row--contact">
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">전화번호</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="phone">${this.escapeHtml(phone)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">팩스번호</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="fax">${this.escapeHtml(fax)}</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--label">E-mail</span>
        <span class="doc-bottom-info-cell doc-bottom-info-cell--value"${ce} data-bottom-field="email">${this.escapeHtml(email)}</span>
    </div>
</div>`;
    }

    // ── Step 3: Preview HTML ──
    public buildPreviewHtml() {
        this.collectRichTextData();
        this.syncTopMetaFormData();
        let html = this.template?.template_content || '';
        if (!html) {
            this.previewHtml = this.sanitizer.bypassSecurityTrustHtml('<div style="padding:60px;text-align:center;color:#999;">미리보기 데이터가 없습니다.</div>');
            return;
        }
        html = this.normalizeTopMetaSectionHtml(html, false);
        html = this.removeAttachmentSectionHtml(html);

        // Replace field placeholders with static values
        html = html.replace(/\{\{(\w+)\}\}/g, (match: string, key: string) => {
            const field = this.fieldsMap[key];
            if (!field) return match;
            const val = this.formData[key] ?? field.default ?? '';
            if (!val) return `<span style="color:#ccc;">(미입력)</span>`;
            if (this.isRichEditableField(field)) {
                return this.normalizeRichTextHtml(val);
            }
            if (field.type === 'checkbox') return val ? '☑' : '☐';
            return this.escapeHtml(String(val)).replace(/\n/g, '<br/>');
        });

        html = this.replaceBottomSectionHtml(html, false);

        html = html.replace(/\{\{META_RECIPIENT\}\}/g, this.escapeHtml(this.recipient) || '(없음)');
        html = html.replace(/\{\{META_VIA\}\}/g, this.escapeHtml(this.via) || '');
        html = html.replace(/\{\{META_TITLE\}\}/g, this.buildMetaTitleHtml(false));
        html = html.replace(/\{\{META_DEPARTMENT\}\}/g, this.escapeHtml(this.department));
        html = html.replace(/\{\{META_DOCNUMBER\}\}/g, this.docNumber || '(저장 시 자동발급)');
        html = html.replace(/\{\{META_EXEC_DATE\}\}/g, this.escapeHtml(this.execDate));
        html = html.replace(/\{\{META_DOC_GRADE\}\}/g, this.escapeHtml(this.docGrade));
        html = html.replace(/\{\{META_PUBLICITY\}\}/g, this.escapeHtml(this.publicity));

        html = this.applyDocumentStyleToHtml(html);
        this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(html);
    }

    // ── Input Events ──
    public onDocumentInput(event: Event) {
        const target = event.target as HTMLElement;
        const editableTarget = (target.closest('[contenteditable="true"]') as HTMLElement | null) || target;

        const metaField = editableTarget.getAttribute('data-meta-field');
        if (metaField === 'title') {
            this.activeRichTextElement = editableTarget;
            this.formData._meta_title_html = this.normalizeRichTextHtml(editableTarget.innerHTML);
            this.docTitle = (editableTarget.textContent || '').trim();
            this.rememberCurrentSelection();
            this.syncToolbarStateFromSelection();
            this.queueToolbarRender();
            this.queuePageLayoutMeasure('editor');
            return;
        }
        if (metaField === 'recipient') {
            this.activeRichTextElement = editableTarget;
            this.recipient = (editableTarget.textContent || '').trim();
            this.rememberCurrentSelection();
            this.syncToolbarStateFromSelection();
            this.queueToolbarRender();
            this.queuePageLayoutMeasure('editor');
            return;
        }
        if (metaField === 'reference') {
            this.activeRichTextElement = editableTarget;
            this.via = (editableTarget.textContent || '').trim();
            this.rememberCurrentSelection();
            this.syncToolbarStateFromSelection();
            this.queueToolbarRender();
            this.queuePageLayoutMeasure('editor');
            return;
        }

        // 하단 고정 서식 편집 필드 처리
        const bottomField = editableTarget.getAttribute('data-bottom-field');
        if (bottomField) {
            if (bottomField === 'approval_freeform') {
                this.activeRichTextElement = editableTarget;
                this.formData._approval_line_html = this.normalizeRichTextHtml(editableTarget.innerHTML);
                this.rememberCurrentSelection();
                this.syncToolbarStateFromSelection();
                this.queueToolbarRender();
                this.queuePageLayoutMeasure('editor');
                return;
            }

            const text = (editableTarget.textContent || '').trim();

            const fieldMap: any = {
                collaborator: '_collaborator',
                recipient: '_footer_recipient',
                address: '_footer_address',
                website: '_footer_website',
                phone: '_footer_phone',
                fax: '_footer_fax',
                email: '_footer_email',
                zip: '_footer_zip',
                doc_number: '_footer_doc_number',
                draft_date: '_footer_draft_date',
                receipt: '_footer_receipt',
            };
            if (fieldMap[bottomField]) {
                this.formData[fieldMap[bottomField]] = text;
            }
            this.queuePageLayoutMeasure('editor');
            return;
        }

        const key = editableTarget.getAttribute('data-field-key');
        if (!key) return;
        if (editableTarget.classList.contains('doc-field-richtext')) {
            this.activeRichTextElement = editableTarget;
            this.formData[key] = this.normalizeRichTextHtml(editableTarget.innerHTML);
            const plainText = (editableTarget.textContent || '').trim();
            if (key === 'title') {
                this.docTitle = plainText;
            }
            if (key === 'receiver_org' || key === 'report_to') {
                this.recipient = plainText;
            }
            if (key === 'reference' || key === 'via') {
                this.via = plainText;
            }
            this.rememberCurrentSelection();
            this.syncToolbarStateFromSelection();
            this.queueToolbarRender();
        } else if (target instanceof HTMLInputElement) {
            if (target.type === 'checkbox') {
                this.formData[key] = target.checked;
            } else {
                this.formData[key] = target.value;
            }
        } else if (target instanceof HTMLTextAreaElement) {
            this.formData[key] = target.value;
        } else if (target instanceof HTMLSelectElement) {
            this.formData[key] = target.value;
        }
        this.queuePageLayoutMeasure('editor');
    }

    // ── Formatting Toolbar ──
    public async execFormat(command: string, value?: string) {
        if (!this.executeEditorCommand(command, value)) {
            return;
        }
        await this.service.render();
    }

    public async applyFontSize(value: string) {
        const fontSize = this.normalizeFontSize(value);
        const hasRichTextContext = this.hasRichTextContext();
        if (hasRichTextContext) {
            this.executeEditorCommand('fontSize', this.getLegacyFontSizeValue(fontSize), !this.hasSelectionInRichText());
            this.applyDocumentStyleToLiveContainer();
            this.queuePageLayoutMeasure('editor');
            await this.service.render();
            return;
        }
        this.setDocumentStyle({ fontSize });
        this.buildDocumentHtml();
        this.applyDocumentStyleToLiveContainer();
        this.queuePageLayoutMeasure('editor');
        await this.service.render();
    }

    public async applyFontFamily(value: string) {
        const fontFamily = this.normalizeFontFamily(value || this.defaultDocumentStyle.fontFamily);
        const hasRichTextContext = this.hasRichTextContext();
        if (hasRichTextContext) {
            this.executeEditorCommand('fontName', this.extractPrimaryFontName(fontFamily), !this.hasSelectionInRichText());
            this.applyDocumentStyleToLiveContainer();
            this.queuePageLayoutMeasure('editor');
            await this.service.render();
            return;
        }
        this.setDocumentStyle({ fontFamily });
        this.buildDocumentHtml();
        this.applyDocumentStyleToLiveContainer();
        this.queuePageLayoutMeasure('editor');
        await this.service.render();
    }

    public async applyTextColor(value: string) {
        const textColor = this.normalizeColor(value, this.defaultDocumentStyle.textColor);
        const hasRichTextContext = this.hasRichTextContext();
        if (hasRichTextContext) {
            this.executeEditorCommand('foreColor', textColor, !this.hasSelectionInRichText());
            this.applyDocumentStyleToLiveContainer();
            this.queuePageLayoutMeasure('editor');
            await this.service.render();
            return;
        }
        this.setDocumentStyle({ textColor });
        this.buildDocumentHtml();
        this.applyDocumentStyleToLiveContainer();
        this.queuePageLayoutMeasure('editor');
        await this.service.render();
    }

    public async applyHighlightColor(value: string) {
        const backgroundColor = this.normalizeColor(value, this.defaultDocumentStyle.backgroundColor);
        const hasRichTextContext = this.hasRichTextContext();
        if (hasRichTextContext) {
            this.executeEditorCommand('hiliteColor', backgroundColor, !this.hasSelectionInRichText());
            this.applyDocumentStyleToLiveContainer();
            this.queuePageLayoutMeasure('editor');
            await this.service.render();
            return;
        }
        this.setDocumentStyle({ backgroundColor });
        this.applyDocumentStyleToLiveContainer();
        this.queuePageLayoutMeasure('editor');
        await this.service.render();
    }

    public async applyTextAlign(value: string) {
        const textAlign = this.normalizeTextAlign(value);
        const commandMap: any = {
            left: 'justifyLeft',
            center: 'justifyCenter',
            right: 'justifyRight',
            justify: 'justifyFull',
        };
        const hasRichTextContext = this.hasRichTextContext();
        if (hasRichTextContext) {
            this.executeEditorCommand(commandMap[textAlign] || 'justifyLeft', undefined, !this.hasSelectionInRichText());
            this.applyDocumentStyleToLiveContainer();
            this.queuePageLayoutMeasure('editor');
            await this.service.render();
            return;
        }
        this.setDocumentStyle({ textAlign });
        this.buildDocumentHtml();
        this.applyDocumentStyleToLiveContainer();
        this.queuePageLayoutMeasure('editor');
        await this.service.render();
    }

    // ── Save ──
    public async save(status: string = 'draft') {
        this.saving = true;
        await this.service.render();

        this.collectRichTextData();
        this.syncTopMetaFormData();
        this.formData.approval_lines = [...this.approvalLines];

        const title = this.docTitle || `${this.template.name} - ${this.authorName}`;
        const res = await wiz.call("save", {
            template_id: this.templateId,
            form_data: JSON.stringify(this.formData),
            title: title,
            status: status,
            doc_id: this.docId,
            doc_category: this.selectedCategory || this.department,
            department: this.department,
            org_code: this.orgCode,
            doc_type: this.docType,
            doc_handling: JSON.stringify(this.getDocHandlingArray()),
            recipient: this.recipient,
            via: this.via,
            exec_date: this.execDate,
            doc_grade: this.isUrgent ? '긴급' : this.docGrade,
            publicity: this.publicity,
            record_type: this.recordType,
        });

        this.saving = false;

        if (res.code === 200) {
            const result = res.data?.data || {};
            this.docId = result.id || this.docId;
            if (result.doc_number) {
                this.docNumber = result.doc_number;
            }
            const msg = status === 'completed' ? '문서가 저장되었습니다.' : '임시 저장되었습니다.';
            await this.service.modal.success('알림', msg);
            if (status === 'completed') {
                this.service.href('/docs/history');
                return;
            }
        } else {
            await this.service.modal.error('오류', res.data?.message || '저장 실패');
        }
        await this.service.render();
    }

    private collectRichTextData() {
        if (!this.docContainer) return;
        const container = this.docContainer.nativeElement;
        const richFields = container.querySelectorAll('.doc-field-richtext');
        richFields.forEach((el: HTMLElement) => {
            this.collectRichTextElementData(el);
        });
    }

    private waitForRenderFrame(): Promise<void> {
        return new Promise((resolve) => {
            requestAnimationFrame(() => resolve());
        });
    }

    private buildDownloadFilename(format: string, baseName: string): string {
        const safeBaseName = String(baseName || this.template?.name || 'document')
            .trim()
            .replace(/[\\/:*?"<>|]+/g, '_')
            .replace(/\s+/g, ' ')
            .trim();

        return `${safeBaseName || 'document'}.${format}`;
    }

    private async createPdfExportRoot(): Promise<HTMLElement> {
        this.buildPreviewHtml();
        await this.service.render();
        await this.waitForRenderFrame();

        const previewHost = this.previewContainer?.nativeElement as HTMLElement | undefined;
        const docRoot = previewHost?.querySelector('.doc-container') as HTMLElement | null;
        if (!docRoot) {
            throw new Error('PDF로 변환할 미리보기 문서를 찾을 수 없습니다.');
        }

        const layout = this.getPageLayout();
        const exportRoot = document.createElement('div');
        exportRoot.style.position = 'fixed';
        exportRoot.style.left = '-200vw';
        exportRoot.style.top = '0';
        exportRoot.style.width = `${layout.widthMm}mm`;
        exportRoot.style.minHeight = `${layout.heightMm}mm`;
        exportRoot.style.padding = `${layout.marginTopMm}mm ${layout.marginRightMm}mm ${layout.marginBottomMm}mm ${layout.marginLeftMm}mm`;
        exportRoot.style.boxSizing = 'border-box';
        exportRoot.style.background = '#ffffff';
        exportRoot.style.color = '#000000';
        exportRoot.style.pointerEvents = 'none';
        exportRoot.style.zIndex = '-1';
        exportRoot.style.overflow = 'hidden';

        const clonedDoc = docRoot.cloneNode(true) as HTMLElement;
        clonedDoc.style.width = '100%';
        clonedDoc.style.maxWidth = 'none';
        clonedDoc.style.margin = '0';
        exportRoot.appendChild(clonedDoc);
        document.body.appendChild(exportRoot);

        if ('fonts' in document && document.fonts?.ready) {
            try {
                await document.fonts.ready;
            } catch (_error) {
                // Font loading failure should not block PDF export.
            }
        }

        await this.waitForRenderFrame();
        return exportRoot;
    }

    private async downloadPdfFromPreview(title: string) {
        const layout = this.getPageLayout();
        const filename = this.buildDownloadFilename('pdf', title);
        const exportRoot = await this.createPdfExportRoot();
        const options: any = {
            margin: 0,
            filename,
            image: {
                type: 'jpeg',
                quality: 0.98,
            },
            enableLinks: true,
            pagebreak: {
                mode: ['css', 'legacy'],
            },
            html2canvas: {
                scale: Math.max(2, Math.min(3, window.devicePixelRatio || 1)),
                useCORS: true,
                backgroundColor: '#ffffff',
                logging: false,
                scrollX: 0,
                scrollY: 0,
            },
            jsPDF: {
                unit: 'mm',
                format: [layout.widthMm, layout.heightMm],
                orientation: layout.orientation === 'landscape' ? 'landscape' : 'portrait',
            },
        };

        try {
            await html2pdf().set(options).from(exportRoot).save();
        } finally {
            exportRoot.remove();
        }
    }

    private async downloadGeneratedFile(format: string, title: string, meta: any) {
        const formData = new FormData();
        formData.append('template_id', this.templateId);
        formData.append('form_data', JSON.stringify(this.formData));
        formData.append('title', title);
        formData.append('format', format);
        formData.append('meta', JSON.stringify(meta));

        const response = await fetch(wiz.url('download'), {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        });

        if (!response.ok) {
            let message = '다운로드 실패';
            try {
                const errorData = await response.clone().json();
                message = errorData?.message || errorData?.data?.message || message;
            } catch (_error) {
                const errorText = await response.text();
                if (errorText) {
                    message = errorText;
                }
            }
            throw new Error(message);
        }

        const responseBlob = await response.blob();
        const blob = format === 'hwpx'
            ? new Blob([responseBlob], { type: 'application/hwp+zip' })
            : responseBlob;
        const contentDisposition = response.headers.get('Content-Disposition') || '';
        let filename = this.buildDownloadFilename(format, title);
        const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
        const filenameMatch = contentDisposition.match(/filename[^*][^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
        if (filenameStarMatch && filenameStarMatch[1]) {
            filename = decodeURIComponent(filenameStarMatch[1]);
        } else if (filenameMatch && filenameMatch[1]) {
            filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
        }

        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(anchor);
        }, 0);
    }

    // ── Download ──
    public async download(format: string) {
        this.downloading = true;
        await this.service.render();

        this.collectRichTextData();
        this.syncTopMetaFormData();
        this.formData.approval_lines = [...this.approvalLines];

        const title = this.docTitle || `${this.template.name} - ${this.authorName}`;
        const meta = {
            department: this.department,
            org_code: this.orgCode,
            doc_type: this.docType,
            recipient: this.recipient,
            via: this.via,
            reference: this.via,
            exec_date: this.execDate,
            doc_grade: this.isUrgent ? '긴급' : this.docGrade,
            publicity: this.publicity,
            doc_number: this.docNumber,
            author_name: this.authorName,
        };

        try {
            await this.downloadGeneratedFile(format, title, meta);
        } catch (e: any) {
            await this.service.modal.error('오류', e.message || '다운로드 중 오류 발생');
        } finally {
            this.downloading = false;
            await this.service.render();
        }
    }

    public goBack() {
        this.service.href('/docs');
    }
}

export default PageDocsFormComponent;